import { PublicClientApplication, BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

export function createMsalInstance(tenantId: string, clientId: string): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/common`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: `${window.location.origin}/login`,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function createMsalGuardConfig(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    loginFailedRoute: '/login',
  };
}

export function createMsalInterceptorConfig(clientId: string): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    // An interactive fallback must never complete off the surviving Microsoft session cookie:
    // clearing the MSAL cache does not end the session at the identity provider, so without a
    // prompt an invitee could be signed back in as whoever last used the browser. Ignored on the
    // silent path — MSAL downgrades it to prompt=none there.
    authRequest: { prompt: 'select_account' },
    protectedResourceMap: new Map([
      // Public OTP endpoints (permitAll on the BE) — must never trigger an Azure token
      // acquisition, or an unauthenticated OTP user gets redirected into Microsoft login.
      [`${environment.apiBaseUrl}/api/v1/auth/*`, null],
      // Same reasoning for the invitation lookup: it runs before any session exists, so requiring
      // an Azure token here would bounce every invitee into Microsoft login. Restricted to GET to
      // mirror the backend, which keeps accepting an invitation authenticated — this wildcard spans
      // slashes (unlike the backend's single-segment matcher) and would otherwise cover that too.
      [`${environment.apiBaseUrl}/api/v1/invitations/*`, [{ httpMethod: 'GET', scopes: null }]],
      [`${environment.apiBaseUrl}/api/*`, [`api://${clientId}/access_as_users`]],
    ]),
  };
}
